module.exports = __webpack_public_path__ + "img/logo-light.6086b863.png";